import * as React from 'react';

// tslint:disable:max-line-length
export const RoadIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
    <g fillRule="nonzero">
      <path d="M9 10v5c0 .6-.4 1-1 1H6c-.6 0-1-.4-1-1v-5h4zM13 2l3 3-3 3H1c-.6 0-1-.4-1-1V3c0-.6.4-1 1-1h12zM6 0h2c.6 0 1 .4 1 1v1H5V1c0-.6.4-1 1-1z" />
    </g>
  </svg>
);
